__turbopack_context__.v({
  "mbl": "panelTools-module-scss-module__ilufIq__mbl",
  "mbm": "panelTools-module-scss-module__ilufIq__mbm",
  "mbn": "panelTools-module-scss-module__ilufIq__mbn",
  "mbs": "panelTools-module-scss-module__ilufIq__mbs",
  "mbx": "panelTools-module-scss-module__ilufIq__mbx",
  "mbxl": "panelTools-module-scss-module__ilufIq__mbxl",
  "mbxxl": "panelTools-module-scss-module__ilufIq__mbxxl",
  "ml": "panelTools-module-scss-module__ilufIq__ml",
  "mll": "panelTools-module-scss-module__ilufIq__mll",
  "mlm": "panelTools-module-scss-module__ilufIq__mlm",
  "mln": "panelTools-module-scss-module__ilufIq__mln",
  "mls": "panelTools-module-scss-module__ilufIq__mls",
  "mlx": "panelTools-module-scss-module__ilufIq__mlx",
  "mlxl": "panelTools-module-scss-module__ilufIq__mlxl",
  "mlxxl": "panelTools-module-scss-module__ilufIq__mlxxl",
  "mm": "panelTools-module-scss-module__ilufIq__mm",
  "mn": "panelTools-module-scss-module__ilufIq__mn",
  "mrl": "panelTools-module-scss-module__ilufIq__mrl",
  "mrm": "panelTools-module-scss-module__ilufIq__mrm",
  "mrn": "panelTools-module-scss-module__ilufIq__mrn",
  "mrs": "panelTools-module-scss-module__ilufIq__mrs",
  "mrx": "panelTools-module-scss-module__ilufIq__mrx",
  "mrxl": "panelTools-module-scss-module__ilufIq__mrxl",
  "mrxxl": "panelTools-module-scss-module__ilufIq__mrxxl",
  "ms": "panelTools-module-scss-module__ilufIq__ms",
  "mtl": "panelTools-module-scss-module__ilufIq__mtl",
  "mtm": "panelTools-module-scss-module__ilufIq__mtm",
  "mtn": "panelTools-module-scss-module__ilufIq__mtn",
  "mts": "panelTools-module-scss-module__ilufIq__mts",
  "mtx": "panelTools-module-scss-module__ilufIq__mtx",
  "mtxl": "panelTools-module-scss-module__ilufIq__mtxl",
  "mtxxl": "panelTools-module-scss-module__ilufIq__mtxxl",
  "mx": "panelTools-module-scss-module__ilufIq__mx",
  "mxl": "panelTools-module-scss-module__ilufIq__mxl",
  "mxxl": "panelTools-module-scss-module__ilufIq__mxxl",
  "pbl": "panelTools-module-scss-module__ilufIq__pbl",
  "pbm": "panelTools-module-scss-module__ilufIq__pbm",
  "pbn": "panelTools-module-scss-module__ilufIq__pbn",
  "pbs": "panelTools-module-scss-module__ilufIq__pbs",
  "pbx": "panelTools-module-scss-module__ilufIq__pbx",
  "pbxl": "panelTools-module-scss-module__ilufIq__pbxl",
  "pbxxl": "panelTools-module-scss-module__ilufIq__pbxxl",
  "pl": "panelTools-module-scss-module__ilufIq__pl",
  "pll": "panelTools-module-scss-module__ilufIq__pll",
  "plm": "panelTools-module-scss-module__ilufIq__plm",
  "pln": "panelTools-module-scss-module__ilufIq__pln",
  "pls": "panelTools-module-scss-module__ilufIq__pls",
  "plx": "panelTools-module-scss-module__ilufIq__plx",
  "plxl": "panelTools-module-scss-module__ilufIq__plxl",
  "plxxl": "panelTools-module-scss-module__ilufIq__plxxl",
  "pm": "panelTools-module-scss-module__ilufIq__pm",
  "pn": "panelTools-module-scss-module__ilufIq__pn",
  "prl": "panelTools-module-scss-module__ilufIq__prl",
  "prm": "panelTools-module-scss-module__ilufIq__prm",
  "prn": "panelTools-module-scss-module__ilufIq__prn",
  "prs": "panelTools-module-scss-module__ilufIq__prs",
  "prx": "panelTools-module-scss-module__ilufIq__prx",
  "prxl": "panelTools-module-scss-module__ilufIq__prxl",
  "prxxl": "panelTools-module-scss-module__ilufIq__prxxl",
  "ps": "panelTools-module-scss-module__ilufIq__ps",
  "ptl": "panelTools-module-scss-module__ilufIq__ptl",
  "ptm": "panelTools-module-scss-module__ilufIq__ptm",
  "ptn": "panelTools-module-scss-module__ilufIq__ptn",
  "pts": "panelTools-module-scss-module__ilufIq__pts",
  "ptx": "panelTools-module-scss-module__ilufIq__ptx",
  "ptxl": "panelTools-module-scss-module__ilufIq__ptxl",
  "ptxxl": "panelTools-module-scss-module__ilufIq__ptxxl",
  "px": "panelTools-module-scss-module__ilufIq__px",
  "pxl": "panelTools-module-scss-module__ilufIq__pxl",
  "pxxl": "panelTools-module-scss-module__ilufIq__pxxl",
  "title": "panelTools-module-scss-module__ilufIq__title",
  "topOptionLink": "panelTools-module-scss-module__ilufIq__topOptionLink",
  "topOptions": "panelTools-module-scss-module__ilufIq__topOptions",
});
